<template>
  <div class="common-layout">
    <!-- <div class="top">
    </div> -->
    <el-container class="container">
      <!-- 顶部菜单 -->
      <el-header class="header">
        <headers></headers>
      </el-header>
      <el-container class="container_right">
        <router-view></router-view>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import { GetClients, getGDkey } from "@/api/index";
import headers from "@/components/head";
export default {
  data() {
    return {
      value: true, //侧边栏
      aside: 200, //侧边栏宽度
      quanping1: false, //是否全屏
      control: 0,
      theme: "dark", //dark light
      names: "",
      module: [],
    };
  },
  components: {
    headers,
  },
  mounted() {
    // const randcode = localStorage.getItem("token");
    const randcode = sessionStorage.getItem("JigGyrBuasd"); //会话存储
    GetClients({
      keys: randcode,
    }).then((res) => {
      this.names = res.name;
      this.control = res.control;
      this.$store.commit("ChangControl", res.control);
      this.$store.commit("Uname", res.name);

      this.module = JSON.parse(res.module);
      if (this.module.indexOf("溯源") !== -1) {
        this.$store.commit("SyControl", true);
      }
      if (this.module.indexOf("防伪") !== -1) {
        this.$store.commit("FwControl", true);
      }
      if (this.module.indexOf("防串货") !== -1) {
        this.$store.commit("WlControl", true);
      }
      if (this.module.indexOf("分发") !== -1) {
        this.$store.commit("FFControl", true);
      }
    });

    getGDkey().then((res) => {
      if (res.success) {
        var data = JSON.parse(res.data);
        const gd = {
          key: data.key,
          secret: data.secret,
          map: data.map,
        };
        this.$store.commit("ChangGd", gd);
      } else {
        this.$Notice.error({ title: "获取失败！" });
      }
    });
  },
  methods: {
    // 路由跳转
    routers(val) {
      this.sideOn(true);
      this.$router.push(val);
    },
    // 侧边栏开关
    sideOn(a) {
      if (a == null) {
        this.value = !this.value;
      } else {
        this.value = a;
      }
    },
  },
};
</script>
<style scoped>
@import url("//unpkg.com/element-ui@2.15.6/lib/theme-chalk/index.css");

.container {
  height: 100vh;
}

.header {
  background: #fff;
  z-index: 999;
  padding: 0%;
}
</style>
